"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
function insertCharacter(editorState, start, end, char) {
    const prevValue = editorState.list.value[start];
    const nextValue = editorState.list.value[end + 1];
    const value = [{
            char,
            styles: editorState.currentStyles
        }];
    if (char === '\n') {
        value.push({
            char: ' ',
            styles: [],
        });
    }
    let newEditorState = editorState.change({
        isBoundary: editorState.lastChangeType !== constants_1.COMMAND.INSERT_CHARACTER,
        type: constants_1.COMMAND.INSERT_CHARACTER,
        start,
        end,
        value
    }).change({
        type: constants_1.COMMAND.INSERT_CHARACTER,
        start: start + 1,
        end: start + 1
    });
    return newEditorState;
}
exports.default = insertCharacter;
//# sourceMappingURL=insertCharacter.js.map